import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';

export default class CompanyModule extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/company/module/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.data = data;

                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();

        this.httpPost("api/v1/company/module/save", {
            id: this.getCurrentFormId(),
            organizationId: this.state.data.record.organizationId,
            systemModuleId: this.state.data.record.systemModuleId,
            expireDate: this.convertMomentToDb(this.state.data.record.expireDate),
            registerDate: this.convertMomentToDb(this.state.data.record.registerDate),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/company/modules'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setOrganization(e) {
        this.state.data.record.organizationId = e.value;
        this.state.data.record.organizationName = e.label;
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <form method="post" onSubmit={e => this.save(e)}>
                                    <div className="card card-bordered card-preview">
                                        <div className="card-inner">
                                            <div className="row g-4">

                                                <div className="col-lg-9">
                                                    <div className="form-group">
                                                        <label className="form-label">کسب و کار</label>
                                                        <div className="form-control-wrap">
                                                            <SelectAsync
                                                                defaultValue={(this.state.data.record.organizationId != null && this.state.data.record.organizationId != this.defaultGuid()) ? [{ value: this.state.data.record.organizationId, label: this.state.data.record.organizationName }] : null}
                                                                isMulti={false}
                                                                placeholder="انتخاب"
                                                                noOptionsMessage={({ inputValue }) =>
                                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                                }
                                                                loadOptions={(inputValue, callback) => {
                                                                    if (inputValue == '') callback(this.state.data.companies);
                                                                    var list = this.state.data.companies.filter(f => f.label.includes(inputValue));
                                                                    callback(list);
                                                                }
                                                                }
                                                                defaultOptions={this.state.data.companies}
                                                                components={{
                                                                    IndicatorSeparator: () => null,
                                                                }}
                                                                onChange={e => this.setOrganization(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <label className="form-label">ماژول مورد نظر</label>
                                                        <div className="form-control-wrap">
                                                            <select defaultValue={this.state.data.record.systemModuleId} onChange={e => this.state.data.record.systemModuleId = parseInt(e.target.value)} className="form-control">
                                                                <option value="0">انتخاب نمایید</option>
                                                                {this.state.data.systemModules.map(m => <option value={m.id}>{m.title}</option>)}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label className="title1">تاریخ فعال سازی</label>
                                                        <DatePicker
                                                            inputReadOnly={false}
                                                            className="form-control input-sm persian-date"
                                                            placeholder={"تاریخ"}
                                                            isGregorian={false}
                                                            showTodayButton={true}
                                                            timePicker={false}
                                                            onChange={(e) => { this.state.data.record.registerDate = e }}
                                                            value={this.getFormatedDateForDatePicker(this.state.data.record.registerDate)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label className="title1">تاریخ اعتبار</label>
                                                        <DatePicker
                                                            inputReadOnly={false}
                                                            className="form-control input-sm persian-date"
                                                            placeholder={"تاریخ"}
                                                            isGregorian={false}
                                                            showTodayButton={true}
                                                            timePicker={false}
                                                            onChange={(e) => { this.state.data.record.expireDate = e }}
                                                            value={this.getFormatedDateForDatePicker(this.state.data.record.expireDate)}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}